// Keeps mandatory add-on cart lines (tagged with the hidden
// `_mandatory_addon_parent_variant` property by addon-picker.js) in sync with
// their parent product's line in the cart:
//   - Adjusting the parent's quantity (+/-, or typing a new value) adjusts the
//     add-on's quantity to match.
//   - Removing the parent removes the add-on too.
//
// Runs after every `on:cart:change` event (fired by both the sidecart drawer
// and the full cart page, since both share the same cart-item markup and
// dispatch that event identically) by re-deriving the correct state from a
// fresh /cart.js read, rather than trying to intercept every individual
// button click.
//
// Scope note: this only covers add-ons tagged via the product page's
// Add-on picker. A parent added through some other path (e.g. a collection
// page's quick-add) that bypasses that picker won't have its mandatory
// add-on attached in the first place — this script only keeps already-tagged
// lines in sync, it doesn't add missing ones.
(function () {
  var PARENT_VARIANT_PROPERTY = '_mandatory_addon_parent_variant';

  var reconciling = false;

  document.addEventListener('on:cart:change', function () {
    reconcileMandatoryAddons();
  }, false);

  async function reconcileMandatoryAddons() {
    if (reconciling) return;
    reconciling = true;

    try {
      var cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) return;
      var cart = await cartResponse.json();

      // Total quantity of each variant currently in the cart, from "real"
      // (non-mandatory-addon) lines only.
      var parentQuantities = {};
      cart.items.forEach(function (item) {
        if (item.properties && item.properties[PARENT_VARIANT_PROPERTY]) return;
        var variantId = String(item.variant_id);
        parentQuantities[variantId] = (parentQuantities[variantId] || 0) + item.quantity;
      });

      var updates = {};
      var hasUpdates = false;

      cart.items.forEach(function (item) {
        var parentVariantId = item.properties && item.properties[PARENT_VARIANT_PROPERTY];
        if (!parentVariantId) return;

        var desiredQuantity = parentQuantities[String(parentVariantId)] || 0;
        if (desiredQuantity !== item.quantity) {
          updates[item.key] = desiredQuantity;
          hasUpdates = true;
        }
      });

      if (!hasUpdates) return;

      var updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });

      if (updateResponse.ok) {
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      } else {
        console.warn('[cart-mandatory-sync] Failed to sync mandatory add-on quantities.');
      }
    } catch (e) {
      console.error('[cart-mandatory-sync] error:', e);
    } finally {
      reconciling = false;
    }
  }
})();
